export const setMarketplaceTokenMinted = (cache, id) => {
    cache.modify({
        id: `MarketplaceTokensWithStats:${id}`,
        fields: {
            minted: () => true,
        },
    });
};
